// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"35":"b0562799","418":"b487603a","532":"ef745c08","680":"738a5b9d"}[chunkId] + ".css";
};